const localeKey = "appLang";
import { en } from "./en";
import { it } from "./it";
export const kitTranslations = {
    en,
    it,
};
function mergeTranslations(translations, locale, generic) {
    if (translations[locale]) {
        if (!translations[locale].generic) {
            translations[locale].generic = {};
        }
        translations[locale].generic = {
            ...translations[locale].generic,
            ...generic,
        };
    }
}
export function initLocale(translations, defaultLocale) {
    if (!localStorage.getItem(localeKey)) {
        localStorage.setItem(localeKey, defaultLocale);
    }
    for (const locale in kitTranslations) {
        mergeTranslations(translations, locale, kitTranslations[locale]);
    }
    return localStorage.getItem(localeKey);
}
export function saveLocale(locale) {
    localStorage.setItem(localeKey, locale);
}
